import type { OrderStatus } from './orderTypes';

/** Estados operativos: aún requieren acción en cocina / despacho / cierre. */
export const OPEN_ORDER_STATUSES: OrderStatus[] = [
  'pending',
  'confirmed',
  'preparing',
  'ready',
  'dispatched',
  'delivered',
];

export type OrderHistoryKind = 'completed' | 'cancelled' | 'closed';

export function historyStatusesForKind(kind: OrderHistoryKind): OrderStatus[] {
  if (kind === 'completed') return ['picked_up'];
  if (kind === 'cancelled') return ['cancelled'];
  return ['picked_up', 'cancelled'];
}
